/* DIEZ PDP page behaviours (2026-08-05): sticky anchor nav.
   Loaded from sections/diez-pdp-benefits.liquid (always present on the PDP). */
(function () {
  function init() {
    var nav = document.querySelector('.anchors');
    if (!nav || nav.dataset.stickyInit) return;
    nav.dataset.stickyInit = '1';
    var ph = document.createElement('div');
    ph.className = 'anchors-ph';
    nav.parentNode.insertBefore(ph, nav.nextSibling);
    var navTop = 0;
    function onScroll() {
      if (window.pageYOffset > navTop) {
        if (!nav.classList.contains('anchors--fixed')) {
          ph.style.height = nav.offsetHeight + 'px';
          ph.style.display = 'block';
          nav.classList.add('anchors--fixed');
          document.body.classList.add('diez-anchorbar-on');
        }
      } else if (nav.classList.contains('anchors--fixed')) {
        nav.classList.remove('anchors--fixed');
        document.body.classList.remove('diez-anchorbar-on');
        nav.classList.remove('nav-open');
        var b = nav.querySelector('.anchors-burger');
        if (b) b.setAttribute('aria-expanded', 'false');
        ph.style.display = 'none';
      }
    }
    function measure() {
      var wasFixed = nav.classList.contains('anchors--fixed');
      nav.classList.remove('anchors--fixed');
      ph.style.display = 'none';
      var r = nav.getBoundingClientRect();
      navTop = r.top + window.pageYOffset;
      /* On phones the STATIC strip is hidden so the buy decision clears the fold,
         which makes it measure 0 and would pin the bar open from the first pixel
         of scroll. Engage it just below the site header instead. */
      if (!nav.offsetParent || navTop < 10) {
        var hdr = document.querySelector('.diez-site-header');
        navTop = (hdr ? hdr.getBoundingClientRect().height : 69) + 50;
      }
      if (wasFixed) onScroll();
    }
    /* Phone-only burger for the sticky bar's section links (2026-08-20).
       Desktop keeps the links inline; the CSS decides which mode is shown, so the
       JS only has to manage the open/closed state. */
    var burger = nav.querySelector('.anchors-burger');
    function closeNav() {
      nav.classList.remove('nav-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
    }
    if (burger) {
      burger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = nav.classList.toggle('nav-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      nav.querySelectorAll('.anchors-links a').forEach(function (a) {
        a.addEventListener('click', closeNav);
      });
      document.addEventListener('click', function (e) {
        if (nav.classList.contains('nav-open') && !nav.contains(e.target)) closeNav();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeNav();
      });
    }

    /* Publish the offer-bar and anchor-bar heights so the CSS can dock the bar
       and offset anchor jumps without hard-coded numbers (the offer message
       wraps to two lines on narrow phones). 2026-08-20 */
    function publishHeights() {
      var a = document.querySelector('.announce');
      var root = document.documentElement;
      root.style.setProperty('--diez-annc-h', (a ? Math.round(a.getBoundingClientRect().height) : 0) + 'px');
      var wasFixed = nav.classList.contains('anchors--fixed');
      if (!wasFixed) nav.classList.add('anchors--fixed');
      root.style.setProperty('--diez-anchorbar-h', Math.round(nav.getBoundingClientRect().height) + 'px');
      if (!wasFixed) nav.classList.remove('anchors--fixed');
    }
    publishHeights();
    window.addEventListener('resize', publishHeights);

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
